import React from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';
import _ from 'lodash';
import ScheduleElement, { scheduleShape } from './schedule_element';

const ScheduleForm = ({ schedules }) => (
  <div className="week-schedule">
    {_.map(schedules, (schedule, index) => (
      <ScheduleElement
        schedule={schedule}
        index={index}
        key={index}
      />
    ))}
  </div>
);

ScheduleForm.propTypes = {
  schedules: PropTypes.arrayOf(scheduleShape).isRequired,
};

function unmountComponent() {
  ReactDOM.unmountComponentAtNode($('#driver-schedule-form')[0]);
}

export default function setupScheduleForm() {
  const $formContainer = $('#driver-schedule-form');
  if (!$formContainer.length) { return; }
  unmountComponent();
  ReactDOM.render(
    <ScheduleForm
      schedules={$formContainer.data('schedules') || null}
    />, $formContainer[0]);
}
